import React from 'react'
import { CategoriaType, PaginaType } from 'utils/types'
import { PlaceholderReact } from '@components/molecules'
import { ShareButton, WContainer, WImage } from 'components/atoms'
import { Page, RoundHead, Timeline } from 'components/organisms'
import styles from './ListingSettimaneTemplate.module.sass'

interface Props {
  pagina: PaginaType
  categoria: CategoriaType
  defaultContent?: any
}

const ListingSettimaneTemplate = (props: Props) => {
  const { pagina, categoria = { articoli: [] }, defaultContent } = props

  const settimane = categoria.articoli.map((a) => ({ numero: a.numeroSettimana, url: a.url }))

  const badgeImage = categoria.paginaHub?.mainImage

  const icon = categoria.paginaHub ? (
    <div className={styles.badge}>
      {badgeImage && (
        <WImage
          src={badgeImage}
          maxHeight={24}
          maxWidth={24}
          layout="intrinsic"
          alt={categoria.paginaHub.titolo}
          title={categoria.paginaHub.titolo}
          loading="eager"
          className={styles.icon}
        />
      )}
      <span className={`${styles.paginaHub} ${badgeImage ? styles['paginaHub--badged'] : ''}`}>
        {categoria.paginaHub.titolo}
      </span>
    </div>
  ) : null

  return (
    <Page pagina={pagina} item={categoria}>
      <div className={styles.listingSettimaneTemplate}>
        <RoundHead
          breadcrumbs={pagina.breadcrumbs}
          title={categoria.titolo}
          description={categoria.descrizione}
          icon={icon}
          className={styles.roundHead}
          readMore={false}
          size="lg"
        />
        <WContainer>
          {settimane.length > 0 && (
            <Timeline
              settimane={settimane}
              next={categoria.next}
              prev={categoria.prev}
              className={`${styles.timeline} ${styles['timeline--top']}`}
            />
          )}
        </WContainer>
        <div className={styles.content}>
          <WContainer variant="xs">
            <PlaceholderReact
              contentTypeId={categoria.model}
              objectId={categoria.pk}
              pkey="content"
              serverSideContent={defaultContent}
              size="xs"
            />
            <div className={styles.shareBottom}>
              <ShareButton item={categoria} />
            </div>
          </WContainer>
        </div>
        <WContainer>
          {settimane.length > 0 && (
            <Timeline
              settimane={settimane}
              next={categoria.next}
              prev={categoria.prev}
              className={styles.timeline}
            />
          )}
        </WContainer>
      </div>
    </Page>
  )
}

export default ListingSettimaneTemplate
